// Preserves ad-click attribution when navigating from the landing to the
// Shopify checkout. Meta's pixel sets _fbp/_fbc cookies automatically, but we
// also forward the click + campaign params on the URL so Shopify (and Meta's
// server-side / Shopify pixel) can tie the session to the right ad.
const FORWARD_PARAMS = [
  'fbclid',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
]

export function appendAttributionParams(url: string): string {
  if (typeof window === 'undefined') return url
  const current = new URLSearchParams(window.location.search)
  const forward = new URLSearchParams()
  FORWARD_PARAMS.forEach((key) => {
    const val = current.get(key)
    if (val) forward.set(key, val)
  })
  const qs = forward.toString()
  if (!qs) return url
  const sep = url.includes('?') ? '&' : '?'
  return `${url}${sep}${qs}`
}
